import React from "react";
import { Eye, Code2, History, Github, Globe, Cpu } from "lucide-react";

const FEATURES = [
  { icon: Eye, title: "Live preview", text: "A real, clickable preview on desktop, tablet and mobile sizes — updated the moment the AI finishes.", span: "lg:col-span-2" },
  { icon: Cpu, title: "Three AI models", text: "Claude Opus 5.5 for complex builds, Sonnet 5.5 for everyday work, GPT 6 Luna for quick tweaks." },
  { icon: History, title: "Version history", text: "Every change is a version. Preview any earlier one and restore it instantly." },
  { icon: Code2, title: "Real code you own", text: "Browse every file, edit it by hand and save — your edits become a new version.", span: "lg:col-span-2" },
  { icon: Github, title: "ZIP & GitHub", text: "Download the project or push it to your own GitHub repository." },
  { icon: Globe, title: "Hosting & domains", text: "Publish to ishukart.org/p/your-app and set up your own custom domain." },
];

export const Features = () => (
  <section id="features" className="border-y border-slate-200/80 bg-slate-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
      <span className="text-xs font-mono uppercase tracking-wider text-emerald-600">Everything included</span>
      <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-slate-900 max-w-2xl">A full studio for building, shipping and managing your apps.</h2>
      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {FEATURES.map((f, i) => (
          <div key={f.title} className={`group rounded-2xl border border-slate-200/80 bg-white p-6 hover:bg-slate-50 hover:border-sky-300 transition-colors ${f.span || ""}`} data-testid={`feature-card-${i + 1}`}>
            <f.icon size={20} className="text-emerald-600 group-hover:scale-110 transition-transform" />
            <h3 className="mt-5 text-lg font-semibold text-slate-900">{f.title}</h3>
            <p className="mt-2 text-sm text-slate-500 leading-relaxed">{f.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Features;
